<div class="row my-2">
  <div class="col-12 col-md-2">
    <select id="tasklist_status" class="form-select form-select-sm" [(ngModel)]="taskForm.taskStatus" (change)="getTaskData()">
      <option value="-1">- All Tasks -</option>
      <option value="1">Active Tasks</option>
      <option value="0">Inactive Tasks</option>
    </select>
  </div>
  <div class="col-12 col-md-3">
    <button class="btn btn-sm btn-dark" (click)="addTask()">
      <i class="fas fa-fw fa-plus me-1"></i>Add Task
    </button>
  </div>
  <div class="col-12 col-md-4"></div>
  <div class="col-12 col-md-3">
    <input type="text" id="taskSearch" class="form-control form-control-sm"
           [(ngModel)]="taskForm.taskSearch"
           placeholder="Search Tasks"
           (input)="searchChange()" />
  </div>
</div>
<div class="row my-2">
  <div class="col-12">
    <div class="grid_sizer" style="height:70vh !important">
      <ag-grid-angular class="ag-theme-alpine"
                       [rowData]="rowData"
                       [columnDefs]="columnDefs"
                       [rowHeight]="28"
                       [headerHeight]="32"
                       (gridReady)="onGridReady($event)"
                       [rowGroupPanelShow]="'never'"
                       [rowSelection]=rowSelection
                       (selectionChanged)="onSelectionChanged($event)"
                       [pagination]="true"
                       [paginationAutoPageSize]=pageSize
                       style="width: 100%;height:100%;border:0 !important">
      </ag-grid-angular>
    </div>
  </div>
</div>

<div class="backdrop" [ngStyle]="{'display':showModal}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':showModal}" id="taskModal">
  <div class="modal-dialog  modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="container-fluid p-0">
          <div class="row m-0 p-0">
            <div class="col-12 col-md-6 p-0 modal-title"></div>
            <div class="col-12 col-md-6 p-0 text-end">
              <button type="button" class="btn btn-sm btn-light my-1" alt="Close" title="Close" (click)="toggleModal('hide')">
                <i class="fas fa-fw fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <span></span>
      </div>
      <div class="modal-body">
        <app-form-tasks-entry [taskId]="taskForm.taskId" (closeModal)="refreshTasksFromEntry()"></app-form-tasks-entry>
      </div>
      <div class="modal-footer text-center d-none">
        <button type="button" class="btn btn-dark my-1" title="Save" (click)="saveTask()">
          <i class="fas fa-fw fa-save"></i>
        </button>
        <button type="button" class="btn btn-light my-1" alt="Close" title="Close">
          <i class="fas fa-fw fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</div>
